<template>
  <div class="emandate">
    <router-view></router-view>
    <ProgressBar progress="50%" />
    <img src="../../static/images/eMandate.svg" alt="eMandate" class="emandate__image" />
    <p
      class="emandate__description"
    >Payment will be automatically deducted from the linked bank account on due date.</p>
    <div class="emandate__payment-options">
      <p class="emandate__payment-options__title">Select a Payment Mode</p>
      <div class="emandate__payment-options__option" v-for="method in methods" :key="method.method">
        <label class="emandate__payment-options__option__label" :for="method.method">
          <div>
            <img
              :src="`../../static/images/${method.method}.svg`"
              :alt="method.displayName"
              class="emandate__payment-options__option__image"
            />
            {{method.displayName}}
          </div>
          <input
            class="emandate__payment-options__option__radio"
            type="radio"
            :value="method.method"
            name="method"
            :id="method.method"
            v-model="selectedMethod"
          />
        </label>
      </div>
      <p class="emandate__payment-options__disclaimer">
        <img
          class="emandate__payment-options__disclaimer__image"
          src="../../static/images/info-2.svg"
          alt="info icon"
        /> ₹1 will be deducted from your account
      </p>
    </div>
    <div class="emandate__terms">
      <input
        class="emandate__terms__checkbox"
        type="checkbox"
        name="terms"
        id="terms"
        v-model="agreeToTerms"
      />
      <label class="emandate__terms__label" for="terms">
        By linking your account, you agree to ePayLater's
        <a
          href="https://epaylater.in/term.html"
        >terms and conditions</a>
      </label>
    </div>
    <ActionButton
      @click="registerEmandate"
      title="Continue"
      :disabled="!agreeToTerms||!selectedMethod"
    />
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import ProgressBar from "@/components/ProgressBar";
export default {
  name: "eMandate",
  computed: {},
  data() {
    return {
      methods: [],
      selectedMethod: undefined,
      agreeToTerms: undefined
    };
  },
  components: {
    ActionButton,
    ProgressBar
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "SCREEN",
      propertyName: "SCREEN_NAME",
      propertyValue: this.selectedMethod
    });
    this.$store
      .dispatch("emandate_methods")
      .then(response => (this.methods = response.enabledMethods));
  },
  methods: {
    registerEmandate() {
      this.$store.dispatch("storeMixpanelEvent", {
        eventName: "EMANDATE_STARTED",
        propertyName: "PAYMENT_METHOD",
        propertyValue: "PENDING"
      });
      const form = document.createElement("form");
      const element1 = document.createElement("input");
      const element2 = document.createElement("input");
      form.style.display = "none";
      form.method = "POST";
      form.action = `${process.env.API_ROOT}/api/v3/user/register-emandate`;
      element1.value = this.selectedMethod;
      element1.name = "method";
      element2.value = "WEB";
      element2.name = "deviceType";
      form.appendChild(element1);
      form.appendChild(element2);
      document.body.appendChild(form);
      form.submit();
    }
  }
};
</script>

<style lang="scss" scoped>
.emandate {
  display: grid;
  justify-items: center;
  padding: 2rem 0;
  &__image {
    margin-bottom: 3.5rem;
  }
  &__description {
    font-size: 1.6rem;
    text-align: center;
    color: var(--gray-9);
    max-width: 40rem;
    text-align: center;
    margin-bottom: 3.5rem;
  }
  &__payment-options {
    width: 100%;
    margin-bottom: 3.5rem;
    &__title {
      font-size: 1.6rem;
      letter-spacing: 0.055rem;
      color: var(--gray-1);
    }
    &__option {
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__image {
        margin-right: 1.8rem;
      }
      &__label {
        padding: 2rem 0.5rem;
        font-size: 1.6rem;
        color: var(--gray-2);
        letter-spacing: 0.055rem;
        flex: 1;
        margin: 0.5rem 0;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        justify-content: space-between;
        align-items: center;
        &:hover {
          opacity: 0.9;
          background: var(--gray-5);
        }
      }
    }
    &__disclaimer {
      font-size: 1.2rem;
      font-weight: 300;
      letter-spacing: 0.02rem;
      color: var(--gray-2);
      display: flex;
      align-items: center;
      &__image {
        margin-right: 0.5rem;
      }
    }
  }
  &__terms {
    display: flex;
    align-items: start;
    &__checkbox {
      margin: 0;
      margin-right: 0.5rem;
    }
    &__label {
      margin-bottom: 0;
      font-size: 1.6rem;
      color: var(--gray-7);
    }
  }
  &__progress {
    height: 1.6rem;
    background: var(--gray-10);
    width: 100%;
    border-radius: 3rem;
    &__done {
      width: 100%;
      height: 1.6rem;
      background: linear-gradient(
        90deg,
        rgba(52, 130, 253, 1) 0%,
        rgba(255, 255, 255, 1) 120%
      );
      border-radius: 3rem;
    }
  }
}
.action-button {
  max-width: 27rem;
}
</style>



// WEBPACK FOOTER //
// src/components/eMandate.vue